/**
 * Load More — generic factory
 *
 * Used by both the blog archive and the video archive.
 * Pass a config object describing which elements and AJAX action to use.
 *
 * @param {Object} config
 * @param {string} config.gridId  — id of the <ul> grid element
 * @param {string} config.btnId   — id of the load-more <button>
 * @param {string} config.wrapId  — id of the wrapper div containing the button
 * @param {string} config.action  — wp_ajax action name
 */
export function initLoadMore( { gridId, btnId, wrapId, action } ) {
    const btn  = document.getElementById( btnId );
    if ( ! btn ) return;

    const grid = document.getElementById( gridId );
    const wrap = document.getElementById( wrapId );

    btn.addEventListener( 'click', async () => {
        const page     = parseInt( btn.dataset.page, 10 );
        const nonce    = btn.dataset.nonce;
        const category = btn.dataset.category || '';
        const tag      = btn.dataset.tag      || '';

        btn.disabled    = true;
        btn.textContent = 'Loading\u2026';

        try {
            const body = new FormData();
            body.append( 'action', action );
            body.append( 'nonce',  nonce );
            body.append( 'page',   page );
            if ( category ) body.append( 'category', category );
            if ( tag )      body.append( 'tag',      tag );

            const res  = await fetch( window.ohpAjax.ajaxurl, { method: 'POST', body } );
            const data = await res.json();

            if ( data.success && data.data.html ) {
                const tmp = document.createElement( 'ul' );
                tmp.innerHTML = data.data.html;
                Array.from( tmp.children ).forEach( li => grid.appendChild( li ) );

                if ( window.UIkit ) UIkit.update( grid );

                btn.dataset.page = page + 1;
                btn.disabled     = false;
                btn.textContent  = 'View More';

                if ( ! data.data.has_more ) wrap.remove();
            } else {
                wrap.remove();
            }

        } catch ( err ) {
            console.error( `Load more failed (${action}):`, err );
            btn.disabled    = false;
            btn.textContent = 'View More';
        }
    } );
}

/** Convenience initialiser for the blog archive. */
export default function initBlogLoadMore() {
    initLoadMore( {
        gridId: 'blog-grid',
        btnId:  'blog-load-more',
        wrapId: 'blog-load-more-wrap',
        action: 'ohp_load_more_posts',
    } );
}
